import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES } from "../data/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-[#050505] pt-20">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid gap-14 lg:grid-cols-[1.3fr_1fr_1.2fr]">
          {/* CTA */}
          <div>
            <p className="text-accent text-xs uppercase tracking-[0.25em] font-bold">
              Since {COMPANY.since}
            </p>
            <h2 className="font-display mt-4 text-4xl md:text-5xl font-black leading-none tracking-tight">
              Let&apos;s keep your <br /> facility running.
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-accent px-6 py-3 text-sm font-bold text-black transition-transform duration-200 hover:scale-[0.97]"
            >
              Request a Quote <ArrowUpRight size={16} />
            </Link>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-bold">Services</h3>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services/${s.id}`}
                    className="text-sm text-neutral-300 hover:text-accent transition-colors duration-200"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-bold">Get in touch</h3>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex gap-3 text-neutral-300">
                <Phone size={17} className="mt-0.5 text-accent shrink-0" />
                <a href={`tel:${COMPANY.phone}`} className="hover:text-white">{COMPANY.phoneDisplay}</a>
              </li>
              <li className="flex gap-3 text-neutral-300">
                <Mail size={17} className="mt-0.5 text-accent shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all">{COMPANY.email}</a>
              </li>
              <li className="flex gap-3 text-neutral-300">
                <MapPin size={17} className="mt-0.5 text-accent shrink-0" />
                <span className="leading-relaxed">{COMPANY.address}</span>
              </li>
            </ul>
            <p className="mt-5 text-xs text-neutral-500">
              Operating across {COMPANY.cities.join(" - ")}
            </p>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="mt-16 overflow-hidden">
          <h2 className="font-display font-black leading-[0.8] tracking-tighter text-[19vw] text-white/[0.05] select-none">
            SUNDROP
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-3 border-t border-white/10 py-7 text-xs text-neutral-500">
          <p>&copy; {new Date().getFullYear()} {COMPANY.legal}. All rights reserved.</p>
          <p>{COMPANY.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
